<template>
  <main class="main animated fadeIn faster" :class="{ 'expand-main': isMenuCollapse }">
    <div class="row mx-1">
      <!-- Header -->
      <!-- <div class="col-12 text-center header-bg py-3">
        <h1 class="my-2 text-dark">Test de llamada – Merci Hubert</h1>
        <p class="mb-0">Évaluez vos compétences de vente SEO et obtenez un rendez-vous.</p>
      </div> -->

      <!-- Contenido principal -->
      <div class="col-12 col-lg-12 mx-auto mt-3">
        <!-- Bloque superior: Bienvenida / Instrucciones -->
        <div class="card shadow-sm rounded-3 mb-4">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe src="https://adaptive-nectarine-029.notion.site/ebd/Bienvenue-Chez-Merci-Hubert-2776c45e9568801a9d54fffff2eca92c" width="100%"
              height="1200" frameborder="0" allowfullscreen />
          </div>
        </div>
        <!-- <div class="card shadow-sm rounded-3 mb-4">
          <div class="card-body p-4">
            <h2 class="h3 mb-3"><strong>Bienvenue à bord !</strong></h2>
            <p class="mb-2">
              Félicitations pour la création de votre compte. Pour poursuivre votre processus d’inscription, vous allez
              participer à un test interactif :
              un appel avec un agent virtuel. Lors de cet échange, votre mission sera de
              <strong>présenter et vendre une solution SEO développée par notre agence</strong>.
            </p>
            <h3 class="h5 mt-3"><strong>Ce qu’il faut savoir sur la solution SEO :</strong></h3>
            <p class="mb-2">
              Notre agence SEO propose une stratégie <strong>entièrement personnalisée</strong>, axée sur l’optimisation
              technique, sémantique et de contenu
              (métadonnées, maillage interne, vitesse, etc.), ainsi qu’une <strong>stratégie de netlinking
                puissante</strong> pour stimuler le trafic organique
              et générer un retour sur investissement durable. Nous utilisons en complément <strong>une approche
                data-driven</strong>, alimentée par des audits,
              des tableaux de bord et des outils propriétaires, pour prioriser les actions ayant le plus fort impact.
            </p>
            <p class="mb-2">Votre objectif au cours de l’appel :</p>
            <ul class="mb-2">
              <li>
                <strong>Vendre la solution SEO</strong> de manière convaincante (visibilité, performance SEO, ROI,
                approche sur mesure, expertise technique et data-driven).
              </li>
              <li><strong>Obtenir un rendez-vous de présentation</strong> avec votre responsable.</li>
            </ul>
            <p class="mb-2">Bonne nouvelle : vous disposez de <strong>jusqu’à 5 tentatives</strong> !</p>
            <p class="mb-0"><strong>Nos équipes analyseront vos appels</strong> et décideront la suite du processus.</p>
          </div>
        </div> -->

        <!-- Bloque inferior: dos columnas -->
        <div class="row g-3">
          <!-- Columna izquierda: Script/Widget de llamada -->
          <div class="col-12 col-lg-3">
            <div class="card shadow-sm rounded-3 h-100 card-script">
              <div class="card-body p-4 text-center">
                <h3 class="h5 mb-3"><strong>{{ $t("lang.elevenlab.call-script") }}</strong></h3>

                <div class="d-flex justify-content-center align-items-center gap-3 mb-3">
                  <span class="badge rounded-pill px-3 py-2 bg-warning text-dark">
                    {{ $t("lang.elevenlab.attempts-remains", { attemptsLeft, attemptsMax }) }}
                  </span>
                </div>

                <div v-if="attemptsLeft === 0" class="alert alert-secondary mt-3" role="alert">
                  {{ $t("lang.elevenlab.no-attempts") }}
                </div>

                <div v-else>
                  <div v-if="!convaiReady" class="text-muted py-4">{{ $t("lang.elevenlab.loading") }}</div>

                  <div v-else-if="user.id" class="convai-wrap">
                    <!-- IMPORTANTe: dynamic-variables (no "variables") y user-id -->
                    <elevenlabs-convai ref="convai" agent-id="agent_6701k18kepm4fjaa3k5atc5rz31c" variant="full"
                      open="true" :user-id="convaiUserId" :dynamic-variables="convaiDynVarsJson"></elevenlabs-convai>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Columna derecha: Historial -->
          <div class="col-12 col-lg-9">
            <div class="card shadow-sm rounded-3 h-100">
              <div class="card-body p-4">
                <h3 class="h5 mb-3"><strong>{{ $t("lang.elevenlab.history") }}</strong></h3>

                <div v-if="loadingHistory" class="text-center py-4">{{ $t("lang.elevenlab.loading") }}</div>
                <div v-else-if="calls.length === 0" class="text-center py-4 text-muted">{{ $t("lang.elevenlab.no-calls")
                  }}</div>

                <div v-else class="table-responsive">
                  <table class="table align-middle">
                    <thead>
                      <tr>
                        <th>{{ $t("lang.elevenlab.date-time") }}</th>
                        <th>Booker</th>
                        <!-- <th>Duración</th> -->
                        <!-- <th>Estado</th> -->
                        <th>Audio</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="call in calls" :key="call.id">
                        <td>{{ formatDate(call.created) }}</td>
                        <td>{{ call.booker_name || fullName }}</td>
                        <!-- <td>{{ formatDuration(call.duration_seconds) }}</td> -->
                        <!-- <td>
                          <span class="badge text-uppercase" :class="statusClass(call.status)">{{ call.status }}</span>
                        </td> -->
                        <td>
                          <audio controls v-if="call.audio">
                            <source :src="audioFormatUrl(call.audio.audio_base64)" type="audio/mpeg">

                          </audio>
                          <span v-else class="text-muted">{{ $t("lang.elevenlab.no-calls") }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <small class="text-muted">{{ $t("lang.elevenlab.audio-private") }}</small>
              </div>
            </div>
          </div>
        </div> <!-- /row -->
        <div class="row">
          <div class="col-12"></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import { bookersService } from "@/_services";
export default {
  name: "BookerTestCall",
  data: function () {
    return {
      attemptsMax: 5,
      attemptsLeft: 5,
      tmpMax: 5,
      getRequest:false,
      calls: [],
      loadingHistory: false,
      pollHandle: null,
      convaiReady: false,
      lastConversationId: null
    };
  },
  computed: {
    ...mapState({
      headerTab: function (state) { return state.header.tab; },
      isMenuCollapse: function (state) { return state.sidebar.isNavOpen; }
    }),
    user: function () {
      var store = this.$store || {};
      var state = store.state || {};
      var auth = state.authentication || {};
      return auth.user || {};
    },
    bookerId: function () {
      var u = this.user || {};
      var b = u.booker || {};
      return b.id || u.id || null;
    },
    fullName: function () {
      var u = this.user || {};
      var f = u.first_name || u.firstname || "";
      var l = u.last_name || u.lastname || "";
      var name = (f + " " + l).trim();
      return name || "—";
    },
    // Valor para el atributo user-id:
    convaiUserId: function () {
      return this.bookerId || (this.user && this.user.id) || "";
    },
    // JSON string para el atributo dynamic-variables:
    convaiDynVarsJson: function () {
      return JSON.stringify({
        booker_external_id: this.bookerId,
        booker_name: this.fullName || null,
        booker_email: (this.user && this.user.email) || null
      });
    }
  },
  methods: {
    // ----------------- ConvAI loader -----------------
    loadConvaiScriptOnce: async function () {
      var globalVars = {
        booker_external_id: this.bookerId,
        booker_name: this.fullName || null,
        booker_email: (this.user && this.user.email) || null
      };
      window.ELEVENLABS_CONVAI_CONFIG = Object.assign(
        { hideDefaultLauncher: true, dynamicVariables: globalVars, variables: globalVars },
        window.ELEVENLABS_CONVAI_CONFIG || {}
      );

      if (window.customElements && window.customElements.get && window.customElements.get("elevenlabs-convai")) return true;

      var existing = document.querySelector('script[src*="@elevenlabs/convai-widget-embed"]');
      if (existing) {
        return await this.waitForCustomElement();
      }

      await new Promise(function (resolve, reject) {
        var s = document.createElement("script");
        s.src = "https://unpkg.com/@elevenlabs/convai-widget-embed@0.2.0/dist/index.js";
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });

      return await this.waitForCustomElement();
    },

    waitForCustomElement: async function () {
      var t0 = Date.now();
      while (!(window.customElements && window.customElements.get && window.customElements.get("elevenlabs-convai"))) {
        if (Date.now() - t0 > 10000) throw new Error("ConvAI script load timeout");
        await new Promise(function (r) { setTimeout(r, 100); });
      }
      return true;
    },

    applyVarsToElement: function () {
      var el = this.$refs.convai;
      if (!el) return;

      var varsObj = {
        booker_external_id: this.bookerId,
        booker_name: this.fullName || null,
        booker_email: (this.user && this.user.email) || null
      };

      try {
        el.userId = this.convaiUserId;
        el.dynamicVariables = varsObj;
        el.variables = varsObj;

        el.setAttribute("user-id", this.convaiUserId);
        el.setAttribute("dynamic-variables", JSON.stringify(varsObj));
        el.setAttribute("variables", JSON.stringify(varsObj));
      } catch (e) {
        console.warn("applyVarsToElement warn:", e);
      }
    },

    // ----------------- Datos backend -----------------


    fetchCalls: async function (total=true) {
      console.log("fetchCalls");
      if(this.attemptsLeft===0) return;
      if (this.calls.length === 0) this.loadingHistory = true;
      try {
        let data = {
          bdr_user_id: this.user.id,
          getTotal:total
        }
        bookersService.getElevenLabsCalls(data).then((calls) => {
          this.getRequest=true;
          console.log(calls)
          if(total){
            this.tmpMax = this.attemptsMax;
            this.attemptsLeft = Math.max(0, this.attemptsMax - (calls.total_conversations || 0));
            if(this.attemptsLeft !== this.tmpMax){
              this.fetchCalls(false);
            }
            this.getRequest=false;
            return;
          } 
          this.attemptsLeft = Math.max(0, this.attemptsMax - (calls.total_conversations || 0));
          this.calls = calls.conversations || [];
          this.getRequest=false;
        });
      } catch (e) {
        console.error("fetchCalls error:", e);
      } finally {
        this.loadingHistory = false;
      }
    },

    startPolling: function () {
      this.stopPolling();
      var self = this;
      var timeline = this.attemptsLeft > 2 ? 6000 : 2000;
      this.pollHandle = setInterval(function () {
        self.fetchCalls();
      }, timeline);
    },

    stopPolling: function () {
      if (this.pollHandle) {
        clearInterval(this.pollHandle);
        this.pollHandle = null;
      }
    },

    // ----------------- Utilidades -----------------
    formatDate: function (iso) {
      if (!iso) return "—";
      try {
        return new Intl.DateTimeFormat("es-AR", {
          timeZone: "America/Argentina/Catamarca",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        }).format(new Date(iso));
      } catch (e) {
        return iso;
      }
    },

    audioFormatUrl: function (base) {
      let audio = "data:audio/mp3;base64," + (base || "");
      return audio;
    },
    formatDuration: function (sec) {
      var s = Number(sec || 0);
      var m = Math.floor(s / 60);
      var r = s % 60;
      var mm = String(m).padStart(2, "0");
      var ss = String(r).padStart(2, "0");
      return mm + ":" + ss;
    },

    statusClass: function (status) {
      var s = String(status || "").toLowerCase();
      if (s === "success") return "bg-success";
      if (s === "fail") return "bg-danger";
      if (s === "abandoned") return "bg-secondary";
      if (s === "processing") return "bg-warning text-dark";
      return "bg-light text-dark";
    },

    // ----------------- Eventos ConvAI -----------------
    onConvaiMessage: function (e) {
      try {
        const originHost = new URL(e.origin).hostname;
        if (!/(\.|^)elevenlabs\.io$/.test(originHost)) return;
      } catch (_) { return; }

      const d = e.data || {};

      if (d.type === 'convai.conversation_started' || d.event === 'conversation.started') {
        this.lastConversationId = d.conversation_id || d.id || null;
      }

      const ended =
        d.type === 'convai.conversation_ended' ||
        d.event === 'conversation.finished' ||
        d.status === 'done' ||
        d.message === 'conversation_ended';

      if (ended) {
        const convId = d.conversation_id || d.id || this.lastConversationId;
        if (convId) this.onConversationEnded && this.onConversationEnded(convId);
      }
    },

    onConversationEnded: function (conversationId) {
      // Hook para, por ejemplo, refrescar historial/intentos
      this.fetchAttempts();
      this.fetchCalls();
      console.log("Conversación finalizada:", conversationId);
    }
  },

  mounted: async function () {
    await this.fetchCalls();
    try {
      window.addEventListener('message', this.onConvaiMessage);
      
      await this.loadConvaiScriptOnce();
      this.convaiReady = true;

      var self = this;
      this.$nextTick(function () {
        self.applyVarsToElement();
      });
    } catch (e) {
      console.error("ConvAI load error:", e);
    }


    
    this.startPolling();
  },

  beforeDestroy: function () {
    window.removeEventListener('message', this.onConvaiMessage);
    this.stopPolling();
  }
};
</script>

<style scoped>
.header-bg {
  background: #ffeaad;
}

.badge {
  font-size: 0.95rem;
}

.card {
  border: 1px solid #f1f1f1;
}

.table thead th {
  white-space: nowrap;
}

/* .gap-3 { gap: .75rem; } */

/* Centrado y tamaño del widget en su columna */
.convai-wrap {
  position: absolute;

  justify-content: center;
  align-items: center;
  padding: 1rem 0;
}

.card-script {
  position: relative;
  min-height: 600px;
  --gap: 12px;
  /* separación entre card y widget */
  --convai-h: 240px;
  /* alto estimado del widget (ajústalo) */
}

.card-script.show-convai {
  margin-bottom: calc(var(--convai-h) + var(--gap));
}

elevenlabs-convai {
  position: relative;
  justify-content: center;
  align-items: center;
  top: -400px;
  width: 80%;
  max-width: 400px;
  /* ancho máximo visual del widget */
  min-height: 520px;
  margin: 0 auto;
  /* centrado */

}
</style>